/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { stopListItemSchema } from "./stopListItemSchema.ts";

export const stopListItemRequestSchema = stopListItemSchema;
